<template>
    <div class="tree-select scrollable">
        <div class="iheader">
            <div @click="goBack" class="back-arrow"/>
            <div class="title">{{title}}</div>
        </div>

        <div class="ibody">
            <!--Блоки для категории уровня 1-->
            <div class="columns-holder" v-if="_items">
                <div class="columns" :style="{width:(paths.length*100)+'%', marginLeft:-(index*100)+'%'}">
                    <div class="column" v-for="path in paths" :style="{width:(100/paths.length)+'%'}">
                        <div class="item" v-for="item in filterByPath(path)" @click="onSelect(item)">
                            {{item.name}}
                            <span v-if="_items[item._id]&&_items[item._id].childs>0">
                                ({{_items[item._id].childs}})
                                <icon pull="right" name="chevron-right"/>
                            </span>
                            <span v-else>
                                <icon pull="right" size="22" color="#0f4997" :name="selected.includes(item._id)?'check-circle':'circle-o'"/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ifooter">
           <btn m label="Подтвердить категории" pull="right" t="s" i="ok" s="l" @press="onSubmit"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "select-tree",
        props: ["items", "value", "selectedItems"],
        data() {
            return {
                selected: [],
                title: "Выберите категорию",
                paths:["000000000000000000000000"],
                index:0
            }
        },
        updated(){
            this.selected = this.selectedItems;
        },
        computed:{
            _items(){
                let _items = this.items.reduce((ns, item)=>{
                    item.childs = 0;
                    ns[item._id] = item;
                    return ns;
                },{});

                Object.keys(_items).map((itemId)=>{
                    if(!_items[_items[itemId].parent])return;
                    _items[_items[itemId].parent].childs++;
                });

                return _items;
            }
        },
        methods: {
            filterByPath(parent){
                let filtered = this.items.filter((item)=>{
                    return item.parent === parent;
                });
                return filtered;
            },
            onSubmit(){
                this.$emit("onSubmit", this.selected)
            },
            onSelect(item){
                let {_items, index, paths, selected} = this;
                if(_items[item._id].childs>0){
                    this.index++;
                    this.paths[this.index]= item._id;
                } else {
                    if(selected.includes(item._id)){
                        this.selected.splice(selected.indexOf(item._id),1)
                        this.$emit("onSelect", {[item._id]:false});
                    } else {
                        this.selected.push(item._id);
                        this.$emit("onSelect", {[item._id]:true});
                    }

                }
            },
            goBack(){
                if(this.index === 0) return;
                this.index--;
            },
            goHome(){
                this.index = 0;
            },
        }
    }
</script>

<style scoped>
    .tree-select{
        height:100%;
    }
    .iheader{
        background: #0f4997;
        padding:10px;
    }
    .title{
        display: inline-block;
        color:white;
        padding-left:10px;
        vertical-align: top;
        font-size:18px;
    }
    .back-arrow{
        background: url(http://avtopoisk.kz/assets/img/left-arrow.svg);
        background-repeat: none;
        background-size: cover;
        width:24px;
        height:24px;
        display: inline-block;
    }
    .columns-holder{
        overflow:hidden;
    }

    .columns{
        transition: 0.3s margin ease;
    }
    .column{
        float:left;
        border-right:1px solid lightgrey;
        border-left:1px solid lightgrey;
        height: 400px;
        overflow: scroll;
    }


    .item{
        padding:10px;
        border-bottom: 1px solid lightgrey;
        font-size:18px;
    }




</style>